// removed by extract-text-webpack-plugin
module.exports = {"root":"faq--root--3ogX8AvA","content":"faq--content--27wmrWgw","list":"faq--list--i27Yo9_f","category":"faq--category--3onPuluR","item":"faq--item--28FgNjhZ","question":"faq--question--Ak4O-xqv","answer":"faq--answer--1Euza44l"};


//////////////////
// WEBPACK FOOTER
// ./views/faq/styles.css
// module id = ./views/faq/styles.css
// module chunks = 0